import { Loadable, LoadableFactory } from "shared/loadable";

export type Config = {
  queues: Record<string, string>;
};

export type ConfigState = Loadable<Config>;

export const initialConfigState: ConfigState = LoadableFactory.loading();
